/* GET SINGLE SOFT SKILL ABILITY */
export const GET_SOFTSKILLS_ABILITY = "GET_SOFTSKILLS_ABILITY"
export const GET_SOFTSKILLS_ABILITY_SUCCESS = "GET_SOFTSKILLS_ABILITY_SUCCESS"
export const GET_SOFTSKILLS_ABILITY_CLEAN = "GET_SOFTSKILLS_ABILITY_CLEAN"
export const GET_SOFTSKILLS_ABILITY_ERROR = "GET_SOFTSKILLS_ABILITY_ERROR"
